import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import { useLocation } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import PatientsTable from "../components/PatientsTable";

export default function Patients() {
    const { oktaAuth } = useOktaAuth();
    const [activeTab, setActiveTab] = useState("patients");
    const location = useLocation();

    // Set active tab based on current route
    useEffect(() => {
        if (location.pathname === "/patients") {
            setActiveTab("patients");
        }
    }, [location.pathname]);

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f9fbfd",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Header activeTab={activeTab} onTabChange={handleTabChange} onLogout={() => oktaAuth.signOut()} />

            <Container
                maxWidth="xl"
                sx={{
                    flexGrow: 1,
                    py: 4,
                    px: { xs: 2, md: 4 },
                }}
            >
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        color: "#333",
                        fontWeight: 500,
                        mb: 4,
                        fontSize: { xs: "1.8rem", md: "2.2rem" },
                    }}
                >
                    All Patients
                </Typography>

                <PatientsTable showAll={true} />
            </Container>

            <Footer />
        </Box>
    );
}